import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['input', 'hidden', 'container', 'counter']

  connect () {
    super.connect()
    this.maxTags = parseInt(this.element.dataset.tagInputMaxValue || '10', 10)
    this.renderTags()
    this.updateCounter()
  }

  get tags () {
    var val = this.hiddenTarget.value
    if (!val || val.trim() === '') return []
    return val.split(',').map(function (t) { return t.trim() }).filter(Boolean)
  }

  set tags (list) {
    this.hiddenTarget.value = list.join(',')
    this.renderTags()
    this.updateCounter()
  }

  add (e) {
    if (e.type === 'keydown') {
      if (e.key !== 'Enter' && e.key !== ',') return
      e.preventDefault()
    }

    var raw = this.inputTarget.value.trim().replace(/,/g, '')
    if (!raw) return

    var current = this.tags
    if (current.length >= this.maxTags) return

    // Prevent duplicates (case-insensitive)
    var lower = raw.toLowerCase()
    var isDuplicate = current.some(function (t) { return t.toLowerCase() === lower })
    if (isDuplicate) {
      this.inputTarget.value = ''
      return
    }

    current.push(raw)
    this.tags = current
    this.inputTarget.value = ''
  }

  remove (e) {
    var index = parseInt(e.currentTarget.dataset.index, 10)
    var current = this.tags
    current.splice(index, 1)
    this.tags = current
  }

  renderTags () {
    var container = this.containerTarget
    container.innerHTML = ''

    this.tags.forEach(function (tag, index) {
      var pill = document.createElement('span')
      pill.className = 'badge d-inline-flex align-items-center me-2 mb-2'
      pill.style.cssText = 'background-color: #157f83; color: white; font-size: 0.875rem; padding: 6px 12px; border-radius: 20px; font-weight: 500;'

      var text = document.createElement('span')
      text.textContent = tag

      var btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 'btn-close btn-close-white ms-2'
      btn.style.cssText = 'font-size: 0.6rem; filter: brightness(0) invert(1);'
      btn.dataset.action = 'click->tag-input#remove'
      btn.dataset.index = index
      btn.setAttribute('aria-label', 'Remove')

      pill.appendChild(text)
      pill.appendChild(btn)
      container.appendChild(pill)
    })

    // Disable input when at max
    if (this.hasInputTarget) {
      var atMax = this.tags.length >= this.maxTags
      this.inputTarget.disabled = atMax
      this.inputTarget.placeholder = atMax ? 'Maximum tags reached' : 'Type a tag and press Enter'
    }
  }

  updateCounter () {
    if (!this.hasCounterTarget) return
    var count = this.tags.length
    var max = this.maxTags
    this.counterTarget.textContent = count + ' of ' + max + ' tags used'
  }
}
